import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';
import { IMpxVodResponse } from '../../../entity/interface/iMpxVodResponse';

export interface IGetMoviesUsecase {
    execute(feed: string | null, filters: { [key: string]: string | number | boolean }): Promise<IMpxVodResponse>;
}

export class GetMoviesUseCase implements IGetMoviesUsecase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        feed: string | null,
        filters: { [key: string]: string | number | boolean }
    ): Promise<IMpxVodResponse> {
        return this.mpxRepository.getMovies(feed, filters);
    }
}
